import { DetailsList, FontIcon, MarqueeSelection, Selection, SelectionMode, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import '../ComplianceView.scss';
import { MyContext } from '../../../context';
import { IStackTokens, IDetailsColumnStyles } from '@fluentui/react';
import AIAssistantIcon from '../AIAssistant/AIAssistantIcon';
import Utils from '../../common/Utils';

export default class PolicyListView extends Component {
    static contextType = MyContext
    _selection: Selection;

    constructor(props) {
        super(props)
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.props.selectPolicy(this._selection.getSelection().length > 0 ? this._selection.getSelection()[0].id : null)
            }
        });
    }

    headerStyle: Partial<IDetailsColumnStyles> = {
        cellTitle: {
            display: 'block',
            textAlign: 'center',
        }
    }

    getUsersAndGroups = (users, groups) => {
        var result = ""
        result += users.length > 0 ? users.map(x => { return x.username }).join() : "";
        result += groups.length > 0 ? result.length > 0 ? "/" + groups.map(x => { return x.name }).join() : groups.map(x => { return x.name }).join() : "";
        return result;
    }

    getChannelRender = (policy) => {
        var result;
        var channel = policy["channel"];
        var channelList = policy["channelList"];

        if (channelList == null || channelList === undefined) {
            switch (channel) {
                case 'None':
                    result = this.getDivForChannels(false, false, false)
                    break
                case 'Text':
                    result = this.getDivForChannels(true, false, false)
                    break
                case 'Voice':
                    result = this.getDivForChannels(false, true, false)
                    break
                case 'Both':
                    result = this.getDivForChannels(true, true, false)
                    break
            }
        }
        else if (channel == null || channel === undefined || channel == "") {
            const isText = channelList.includes("Text");
            const isVoice = channelList.includes("Voice");
            const isScreen = channelList.includes("Screen");
            const isMail = channelList.includes("Mail");

            result = this.getDivForChannels(isText, isVoice, isScreen, isMail)
        }

        return (
            <span>{result}</span>
        )
    }


    getDivForChannels = (textEnable, voiceEnable, screenshareEnable, mailEnable) => {
        const numericalSpacingStackTokens = {
            childrenGap: 10,
            paddingRight: 10,
        };

        return (
            <Stack horizontal disableShrink tokens={numericalSpacingStackTokens}>
                <span>{textEnable && <FontIcon iconName={"Chat"} style={{ fontSize: "15px" }} />}</span>
                <span>{voiceEnable && <FontIcon iconName={"Microphone"} style={{ fontSize: "15px" }} />}</span>
                <span>{screenshareEnable && <FontIcon iconName={"Screencast"} style={{ fontSize: "15px" }} />}</span>
                <span>{mailEnable && <FontIcon iconName={"Mail"} style={{ fontSize: "15px" }} />}</span>
            </Stack>
        )
    }

    _getKey = (item, index) => {
        return item.key;
    }

    _renderItemColumn = (item, index, column) => {

        const fieldContent = item[column.fieldName]
        switch (column.key) {
            case 'users':
                return <span>{this.getUsersAndGroups(item.users, item.groups)}</span>;
            case 'basedOn': {
                switch (item.basedOn) {
                    case "PolicyRule": {
                        return <div style={{ display: "flex", alignItems: "center" }}>
                            <FontIcon
                                iconName={"TaskManager"}
                                style={{ marginRight: "5px", fontSize: "15px" }}
                            />
                            <span>{item.policyRules !== null ? item.policyRules.map(cat => { return cat.name }).join() : ""}</span>
                        </div>;
                    }
                    case "AICategorization": {
                        return <div style={{ display: "flex", alignItems: "center" }}>
                            <FontIcon
                                iconName={"UserGauge"}
                                style={{ marginRight: "5px", fontSize: "15px" }}
                            />
                            <span>{item.aICategorizationInfos !== null ? item.aICategorizationInfos.map(cat => { return cat.categorizationName }).join() : ""}</span>
                        </div>;
                    }
                    case "Scorecard": {
                        return <div style={{ display: "flex", alignItems: "center" }}>
                            <FontIcon
                                iconName={"TrackersMirrored"}
                                style={{ marginRight: "5px", fontSize: "15px" }}
                            />
                            <span>{item.aIScorecardInfos !== null ? item.aIScorecardInfos.map(s => s.scorecardName).join() : ""}</span>
                        </div>;
                    }
                    case "AIAssistant": {
                        return <div style={{ display: "flex", alignItems: "center" }}>
                            <AIAssistantIcon
                                style={{ marginRight: "5px", marginBottom: "5px" }}
                                height="15px"
                                color="blue"
                                theme={this.props.theme}
                            />
                            <span>{item.aIAssistantQuestions !== null ? item.aIAssistantQuestions.length + " Question(s)" : ""}</span>

                        </div>;
                    }
                    case "ContentUnderstanding": {
                        return <div style={{ display: "flex", alignItems: "center" }}>
                            <FontIcon
                                iconName={"ReceiptTentative"}
                                style={{ marginRight: "5px", fontSize: "15px" }} // Gr��eres Icon
                            />
                            <span>
                                {item.aIAssistantQuestions !== null && item.aIAssistantQuestions.length > 0
                                    ? item.aIAssistantQuestions.length + " Question(s)"
                                    : "Json Schema"}
                            </span>
                        </div>;
                    }
                    default: return <div></div>
                }
            }
            case "active":
                return <span>{<FontIcon iconName={fieldContent ? "CheckboxComposite" : "Checkbox"} style={{ size: "10" }} />}</span>;
            case "channel":
                return this.getChannelRender(item);
            case "riskRating":
                return this.props.getRiskRating(fieldContent);
            case 'supervisors':
                return <span>{(item.supervisors != null && item.supervisors.length > 0) ? item.supervisors.map(sv => sv.username).join() : ""}</span>;
            case "visibleForUsers":
                return <span>{(item.visibleForUsers != null && item.visibleForUsers.length > 0) ? item.visibleForUsers.map(sv => sv.username).join() : ""}</span>
            default:
                return <span>{fieldContent !== null ? fieldContent : ""}</span>;
        }
    }

    getPolicyGroups = (activePolicies, inactivePolicies) => {
        const selectedId = this._selection.getSelection()[0]?.id
        const selectedInActive = selectedId !== undefined ? activePolicies.map(p => p.id).includes(selectedId) : true
        const selectedInInactive = selectedId !== undefined ? inactivePolicies.map(p => p.id).includes(selectedId) : false
        return [
            {
                "key": "active",
                "name": this.context.getTranslation("compliance", "activePolicies"),
                "startIndex": 0,
                "count": activePolicies.length,
                "level": 0,
                "isCollapsed": !selectedInActive
            },
            {
                "key": "inactive",
                "name": this.context.getTranslation("compliance", "noActivePolicies"),
                "startIndex": activePolicies.length,
                "count": inactivePolicies.length,
                "level": 0,
                "isCollapsed": !selectedInInactive
            }
        ]
    }

    render() {
        const columns = [
            { key: 'name', name: this.context.getTranslation("compliance", "detailPolicyName"), fieldName: 'name', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'description', name: this.context.getTranslation("compliance", "detailPolicyDescription"), fieldName: 'description', minWidth: 100, maxWidth: 200 },
            { key: 'channel', name: this.context.getTranslation("compliance", "detailPolicyChannel"), fieldName: 'channel', minWidth: 100, maxWidth: 150 },
            { key: 'riskRating', styles: this.headerStyle, name: this.context.getTranslation("compliance", "detailPolicyRiskRating"), fieldName: 'riskRating', minWidth: 100, maxWidth: 150 },
            { key: 'users', name: this.context.getTranslation("compliance", "detailPolicyUsers"), isResizable: true },
            { key: 'supervisors', name: this.context.getTranslation("compliance", "detailPolicySupervisor"), isResizable: true },
            { key: 'visibleForUsers', name: this.context.getTranslation("compliance", "policyVisibleForUsers"), isResizable: true },
            { key: 'basedOn', name: this.context.getTranslation("compliance", "basedOn"), isResizable: true },
            { key: 'active', name: this.context.getTranslation("compliance", "detailPolicyActive"), fieldName: 'active', minWidth: 80, maxWidth: 80 }
        ]
        let activePolicies = this.props.policies.filter(p => p.active)
        activePolicies.sort((a, b) => Utils.orderAlphabetically.call(null, a.name.toLowerCase(), b.name.toLowerCase()))
        let inactivePolicies = this.props.policies.filter(p => !p.active)
        inactivePolicies.sort((a, b) => Utils.orderAlphabetically.call(null, a.name.toLowerCase(), b.name.toLowerCase()))
        var groups = this.getPolicyGroups(activePolicies, inactivePolicies)
        let data = [...activePolicies, ...inactivePolicies]
        return (
            <MarqueeSelection selection={this._selection}>
                <DetailsList
                    items={data}
                    columns={columns}
                    groups={groups}
                    selectionMode={SelectionMode.single}
                    selection={this._selection}
                    getKey={this._getKey}
                    setKey="single"
                    onRenderItemColumn={this._renderItemColumn}
                />
            </MarqueeSelection>
        )
    }

}